export default __webpack_public_path__ + "static/media/desktop.41385e68.png";